import { useEffect } from 'react';

import { BibleVersionsModal } from './app/modules/bible/components/BibleVersionsModal';
import { autoSavePlaylists } from './app/modules/playlist/middleware';
import { PluginContextProvider, PluginInstallRequestModal } from './app/modules/plugin/components';
import { RendererFrame } from './app/modules/renderer/components/RendererFrame';
import { EditorModal } from './app/modules/resources/components/EditorModal';
import { Loader } from './app/modules/ui/components/Loader';
import { MainWindow } from './app/modules/ui/components/MainWindow';

import './App.css';
import { SettingsDialog } from './app/modules/settings/components/SettingsDialog';
import { useSyncListener } from './app/modules/sync/middleware';
import { usePeriodicSync } from './app/modules/sync/functions';
import { LoginModal } from './app/modules/auth/components/LoginModal';
import { SignupModal } from './app/modules/auth/components/SignupModal';
import { AccountModal } from './app/modules/account/components/AccountModal';
import { LoadPlaylistModal } from './app/modules/playlist/components/LoadPlaylistModal';
import { ResetPasswordModal } from './app/modules/auth/components/ResetPasswordModal';

function App() {

  useEffect(autoSavePlaylists, []);
  useSyncListener();
  usePeriodicSync();

  return (
    <PluginContextProvider>
      <RendererFrame />
      <LoginModal />
      <SignupModal />
      <ResetPasswordModal />
      <PluginInstallRequestModal />
      <Loader />
      <BibleVersionsModal />
      <EditorModal />
      <SettingsDialog />
      <AccountModal />
      <LoadPlaylistModal />
      <MainWindow />
    </PluginContextProvider>
  );
}

export default App;
